export default {
  notilogin:"Yeni cihazdan giriş denendi",
 notiwithdraw:"Başarıyla geri çekildin",
 notideposit:"Almış olduğunuz ",
 notiexchange:'Exchange başarıyla yürütüldü '
};
